import { render, staticRenderFns } from "./EditDispatch.vue?vue&type=template&id=0fbf206b&scoped=true"
import script from "./EditDispatch.vue?vue&type=script&lang=js"
export * from "./EditDispatch.vue?vue&type=script&lang=js"
import style0 from "./EditDispatch.vue?vue&type=style&index=0&id=0fbf206b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbf206b",
  null
  
)

export default component.exports